import { render, staticRenderFns } from "./DecretosNewOrEdit.vue?vue&type=template&id=22023dea&scoped=true&"
import script from "./DecretosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DecretosNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DecretosNewOrEdit.vue?vue&type=style&index=0&id=22023dea&prod&lang=sass&"
import style1 from "./DecretosNewOrEdit.vue?vue&type=style&index=1&id=22023dea&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22023dea",
  null
  
)

export default component.exports